import UsersGridRowWrapper from 'components/UsersGrid/components/UsersGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const UsersGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <UsersGridRowWrapper ref={ref} testId={testId}>
        {children}
    </UsersGridRowWrapper>
);

export default UsersGridHeader;
